// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var MM_react_common = require("../ui-utils/MM_react_common.res.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.res.js");
var JsxPPXReactSupportU = require("rescript/lib/js/jsxPPXReactSupportU.js");
var Add = require("@mui/icons-material/Add").default;
var TextField = require("@mui/material/TextField").default;
var IconButton = require("@mui/material/IconButton").default;
var Delete = require("@mui/icons-material/Delete").default;

function MM_cmp_type_settings(props) {
  var onDelete = props.onDelete;
  var onPrefixChange = props.onPrefixChange;
  var onColorChange = props.onColorChange;
  var onTypeChange = props.onTypeChange;
  var onAdd = props.onAdd;
  var availableColors = props.availableColors;
  var rndTypeSetting = function (ts) {
    var msg = ts.err;
    return JsxPPXReactSupportU.createElementVariadicWithKey(ts.id, Expln_React_Column.make, {
                children: Caml_option.some(null)
              }, [
                React.createElement(Expln_React_Row.make, {
                      children: Caml_option.some(null)
                    }, React.createElement(TextField, {
                          value: ts.typ,
                          label: "Type",
                          size: "small",
                          style: {
                            width: "100px"
                          },
                          onChange: Expln_React_common.evt2str(function (__x) {
                                onTypeChange(ts.id, __x);
                              })
                        }), MM_react_common.rndColorSelect(availableColors, ts.color, (function (__x) {
                            onColorChange(ts.id, __x);
                          }), "Color"), React.createElement(TextField, {
                          value: ts.prefix,
                          label: "Prefix",
                          size: "small",
                          style: {
                            width: "100px"
                          },
                          onChange: Expln_React_common.evt2str(function (__x) {
                                onPrefixChange(ts.id, __x);
                              })
                        }), JsxPPXReactSupportU.createElementWithKey("delete-button", IconButton, {
                          onClick: (function (param) {
                              onDelete(ts.id);
                            }),
                          children: Caml_option.some(React.createElement(Delete, {}))
                        })),
                msg !== undefined ? React.createElement("pre", {
                        style: {
                          color: "red"
                        }
                      }, msg) : null
              ]);
  };
  return React.createElement(Expln_React_Column.make, {
              style: {
                marginTop: "5px"
              },
              children: Caml_option.some(null)
            }, props.typeSettings.map(rndTypeSetting), React.createElement(Expln_React_Row.make, {
                  alignItems: "baseline",
                  children: Caml_option.some(null)
                }, JsxPPXReactSupportU.createElementWithKey("add-button", IconButton, {
                      onClick: (function (param) {
                          onAdd();
                        }),
                      children: Caml_option.some(React.createElement(Add, {}))
                    }), MM_react_common.rndSmallTextBtn(props.onRestoreDefaults, "Restore default type settings", undefined)));
}

var make = MM_cmp_type_settings;

exports.make = make;
/* react Not a pure module */
